var site = site || {};
site.onLoadRpc = site.onLoadRpc || {};

site.onLoadRpc.defaults = {

  analytics_userinfo : {
    from_lbr: 0,
    hashed_email_address: null,
    ident: null,
    is_loyalty_member: 0,
    is_pro: 0,
    keylist: 'from_lbr|is_loyalty_member|is_pro|loyalty_level|mobile_email_optin|pc_email_optin|recognized_user|registered_user|signed_in',
    loyalty_level: 0,
    mobile_email_optin: 0,
    pc_email_optin: 0,
    recognized_user: null,
    registered_user: 0,
    session_id: 00000000,
    signed_in: 0,
    sorted: '0|0|0|0|0|0|0|0|0'
  }

};